export default "__VITE_ASSET__$snM1W$P__"